import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const AboutPage = () => {
  return (
    <main className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50 py-12">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
          About Flippy Homes
        </h1>
        
        <Card className="mb-8">
          <CardContent className="p-8">
            <h2 className="text-2xl font-semibold text-emerald-700 mb-4">Our Story</h2>
            <p className="text-gray-600 mb-4">
              Flippy Homes is South Africa's innovative property marketplace, designed to connect 
              buyers, sellers, renters, and home service professionals in one seamless platform. 
              We believe everyone deserves access to quality property listings and trusted contractors.
            </p>
            <p className="text-gray-600 mb-4">
              Founded with a vision to simplify the South African property market, we combine 
              cutting-edge technology with local expertise to deliver an exceptional experience 
              for all our users.
            </p>
          </CardContent>
        </Card>

        <Card className="mb-8">
          <CardContent className="p-8">
            <h2 className="text-2xl font-semibold text-emerald-700 mb-4">Our Mission</h2>
            <p className="text-gray-600 mb-4">
              To empower South Africans in their property journey by providing a trusted, 
              user-friendly platform that connects people with their perfect homes and 
              reliable home service professionals.
            </p>
          </CardContent>
        </Card>

        <Card className="mb-8">
          <CardContent className="p-8">
            <h2 className="text-2xl font-semibold text-emerald-700 mb-4">What We Offer</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">
                  <i className="fas fa-home text-emerald-600 mr-2"></i>Property Listings
                </h3>
                <p className="text-gray-600 text-sm">
                  Browse thousands of properties for sale and rent across all 9 South African provinces.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">
                  <i className="fas fa-tools text-emerald-600 mr-2"></i>Home Services
                </h3>
                <p className="text-gray-600 text-sm">
                  Find verified contractors including builders, plumbers, electricians, and more.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">
                  <i className="fas fa-bullhorn text-emerald-600 mr-2"></i>Influencer Marketing
                </h3>
                <p className="text-gray-600 text-sm">
                  Connect with social media influencers to promote your property listings.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">
                  <i className="fas fa-calculator text-emerald-600 mr-2"></i>Bond Calculator
                </h3>
                <p className="text-gray-600 text-sm">
                  Calculate your monthly bond repayments with our easy-to-use tool.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-8">
            <h2 className="text-2xl font-semibold text-emerald-700 mb-4">Contact Us</h2>
            <div className="flex flex-col gap-3">
              <a 
                href="https://wa.me/27655249286" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-600 hover:text-emerald-600"
              >
                <i className="fab fa-whatsapp text-green-500 text-xl"></i>
                +27 65 524 9286
              </a>
              <a 
                href="mailto:info@flippyhomes.co.za"
                className="flex items-center gap-3 text-gray-600 hover:text-emerald-600"
              >
                <i className="fas fa-envelope text-emerald-600 text-xl"></i>
                info@flippyhomes.co.za
              </a>
            </div>
          </CardContent>
        </Card>
      </div>
    </main>
  );
};

export default AboutPage;
